<!--  -->
<template>
  <div>
    <el-form label-position="right" label-width="80px" :model="form">
      <el-form-item label="企业员工">
        <el-tag v-for="items,index in form.corp_userid" :key="index" style="margin-right:10px" closable @close="close(index)">{{ items.name }} </el-tag>
        <el-button type="primary" size="mini" @click="chorwe">选择企业员工</el-button>
      </el-form-item>
      <el-form-item label="公众号">
        <el-tag v-if="form.app_id!=''" style="margin-right:10px">{{ official_name }} ({{ form.app_id }}) </el-tag>
        <el-button type="primary" size="mini" @click="choose">选择公众号</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="sumbit">确定</el-button>
      </el-form-item>
    </el-form>

    <el-dialog
      title="选择公众号"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :destroy-on-close="true"
      width="60%"
    >
      <official-choose @official="official" />
    </el-dialog>
    <el-dialog
      title="绑定员工"
      :visible.sync="dialogVisibler"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="60%"
    >
      <bandstaff ref="bandstaffview" @bandarr="bandarr" />
    </el-dialog>
  </div>
</template>

<script>
import officialChoose from '../../behavioralsource/components/officialChoose.vue'
import bandstaff from './bandstaff.vue'
import { staffOfficialCreate } from '@/api/officialaccount.js'
export default {
  components: { officialChoose, bandstaff },
  data() {
    return {
      official_name: '',
      form: {
        app_id: '',
        corp_userid: []
      },
      arr: [],
      dialogVisible: false,
      dialogVisibler: false
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    choose() {
      this.dialogVisible = true
    },
    official(item) {
      // console.log(item)
      this.dialogVisible = false
      this.official_name = item.account_name
      this.form.app_id = item.app_id
    },
    chorwe() {
      this.dialogVisibler = true
      this.$nextTick(() => {
        this.$refs.bandstaffview.sendr('', this.form.corp_userid)
      })
    },
    async bandarr(arr, sp_strategy_no, arrname) {
      this.dialogVisibler = false
      this.form.corp_userid = arr
      console.log(arr)
    },
    close(index) {
      this.form.corp_userid.splice(index, 1)
    },
    async sumbit() {
      console.log('this.form.corp_userid', this.form.corp_userid)
      if (this.form.corp_userid.length === 0) {
        this.$message.error('请选择企业员工')
        return
      }
      if (this.form.app_id === '') {
        this.$message.error('请选择公众号')
        return
      }
      this.arr = []
      this.arr = this.form.corp_userid.map((item) => {
        return { employee_no: item.employee_no }
      })
      console.log(this.arr)
      const data = await staffOfficialCreate({
        corp_user: this.arr,
        app_id: this.form.app_id
      })
      this.$message({
        type: 'success',
        message: '新增成功!'
      })
      this.$emit('updata')
      console.log('data', data)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
